import ForgotPassword from "../../components/forgot-password/forgot-password.component";

export default function ForgotPasswordPage(){
    return <ForgotPassword/>
}